import React from 'react';
import { get, orderBy } from 'lodash';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import PlanCard from '../../components/PlanCard';
import { colors } from '../../styles';

const styles = css`
  padding: 45px 0;
  @media (min-width: 992px) {
    padding: 60px 0;
  }
  .PlanResults_count {
    font-weight: 400;
    margin: 0 0 30px 0;
    color: ${colors.body};
    text-align: center;
  }
  .PlanResults_countValue {
    display: inline-block;
    background-color: ${colors.neutral};
    color: ${colors.body};
    width: 30px;
    height: 30px;
    line-height: 28px;
    border-radius: 50%;
    text-align: center;
    margin: 0 5px 0 0;
  }
`;

function PlansResults({ plans, sort }) {
  return (
    <div className={styles}>
      <div className="container">
        <div className="PlanResults_count">
          <span className="PlanResults_countValue">{plans.length} </span>
          Available Plans
        </div>
        <div className="row justify-content-center">
          {
            orderBy(plans, sort.field, get(sort, 'dir', 'asc')).map(plan => (
              <PlanCard plan={plan} key={plan._id} />
            ))
          }
        </div>
      </div>
    </div>
  );
}

PlansResults.propTypes = {
  plans: PropTypes.arrayOf(PropTypes.object).isRequired,
  sort: PropTypes.object.isRequired,
};

export default withData(
  {
    plans: true,
  },
)(PlansResults);



// WEBPACK FOOTER //
// ./src/pages/Plans/PlansResults.js